import i18n from '@/i18n'

import { NavigationSidebarItem, NavigationSidebarSection } from '@/constants/navigation'

type TranslationFunction = (key: string) => string

export const parseSidebarItems = (
  items: NavigationSidebarItem[],
  t: TranslationFunction,
): NavigationSidebarItem[] => {
  return items.map((item) => {
    return {
      ...item,
      children: item.children ? parseSidebarItems(item.children, t) : undefined,
    }
  })
}

export const getSidebarItems = (sections: NavigationSidebarSection[]): NavigationSidebarSection[] => {
  // Get translations using i18next
  // Ensure i18n is initialized (it should be from the import)
  const t = (key: string) => {
    const fullKey = `sidebar.${key}`
    return i18n.t(fullKey)
  }

  return sections.map((section) => {
    return {
      ...section,
      items: parseSidebarItems(section.items, t),
    }
  })
}
